import { createFrontendPlugin } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { hasRepo } from './util';

const repositoryCard = EntityCardBlueprint.make({
  name: 'repository',
  params: {
    filter: entity => hasRepo(entity),
    loader: async () => {
      const { RepositoryCard } = await import('./RepositoryCard');
      return <RepositoryCard />;
    },
  },
});

const ciCard = EntityCardBlueprint.make({
  name: 'ci',
  params: {
    filter: entity => hasRepo(entity),
    loader: async () => {
      const { CiCard } = await import('./CiCard');
      return <CiCard />;
    },
  },
});

const deploymentCard = EntityCardBlueprint.make({
  name: 'deployment',
  params: {
    filter: entity => hasRepo(entity),
    loader: async () => {
      const { DeploymentCard } = await import('./DeploymentCard');
      return <DeploymentCard />;
    },
  },
});

export const deliveryPlugin = createFrontendPlugin({
  pluginId: 'delivery',
  extensions: [repositoryCard, ciCard, deploymentCard],
});
